// Fever 使用的 lang
export const langTypes = {
    ZH_TW: 'zh-TW',
    ZH_CN: 'zh-CN',
    ZH_HK: 'zh-HK',
    EN_US: 'en-US',
    JA_JP: 'ja',
    PT_BR: 'pt-BR',
    ES_419: 'es-419'
};

// Froala 使用的 lang
export const froalaLangTypes = {
    ZH_TW: 'zh_tw',
    EN_US: 'en',
    JA_JP: 'ja'
};

export const paragraphClass = {
    H1: 'cover-title',
    H2: 'section-title',
    H3: 'section-subtitle',
    H4: 'inner-title',
    N: 'inner',
    DIV: 'caption'
};

export const tableStyleTypes = {
    ALTERNATE: 'fr-alternate-rows',
    THIN: 'froala-thin-borders',
    THICK: 'froala-thick-borders',
    DASHED: 'fr-dashed-borders',
    NO_BORDER: 'froala-no-borders'
};
